module.exports = __webpack_public_path__ + "static/img/anLiBoxImg1.73babb1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/anLiBoxImg1.png
// module id = qM93
// module chunks = 2